import {Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter} from '@angular/core';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {PontoFisico} from '../../comum/modelos/ponto-fisico';

@Component({
  selector: 'app-editar-ponto-fisico',
  templateUrl: './editar-ponto-fisico.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./editar-ponto-fisico.component.css']
})
export class EditarPontoFisicoComponent implements OnInit {

  @Output() editarEvent: EventEmitter<void>;
  @Input() pontoFisico: PontoFisico;
  @Input() idCliente: number;

  public pontoFisicoCopy: PontoFisico;

  constructor(private modalService: NgbModal) {
    this.editarEvent = new EventEmitter<void>();
  }

  ngOnInit() {
  }

  editar(content) {
    this.pontoFisicoCopy = new PontoFisico(this.pontoFisico);
	const ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false,
		windowClass: 'modalPontoFisico',
		size: 'lg'
	};
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.pontoFisico.copyObject(this.pontoFisicoCopy);
      this.editarEvent.emit();
    }, (reason) => {
    });
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/editar-ponto-fisico/editar-ponto-fisico.component.ts